import { ref, computed } from 'vue';
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6cdbae04"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "duplicate-order-content"
};
import { getIncomePermissionMessage } from '@/utils/incomePermission';
import FilterHeader from './components/FilterHeader.vue';
import DuplicateStatic from '@/views/orderManage/duplicateOrder/components/DuplicateStatic.vue';
import DuplicateTable from '@/views/orderManage/duplicateOrder/components/DuplicateTable.vue';
import IncomePermissionNotice from '@/components/IncomePermissionNotice.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'duplicateOrderIndex',
  setup(__props) {
    const tableRef = ref(null);
    const duplicateStaticRef = ref(null);
    const loading = ref(false);
    // 统计和列表分别鉴权；页面合并去重展示，不能仅依赖其中一个接口。
    const permissionMessage = computed(() => {
      var _duplicateStaticRef$v, _tableRef$value;
      return getIncomePermissionMessage([...new Set([...(((_duplicateStaticRef$v = duplicateStaticRef.value) === null || _duplicateStaticRef$v === void 0 || (_duplicateStaticRef$v = _duplicateStaticRef$v.permissionState) === null || _duplicateStaticRef$v === void 0 ? void 0 : _duplicateStaticRef$v.noPermissionDbtIds) || []), ...(((_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 || (_tableRef$value = _tableRef$value.permissionState) === null || _tableRef$value === void 0 ? void 0 : _tableRef$value.noPermissionDbtIds) || [])])]);
    });
    const filterSubmit = obj => {
      var _tableRef$value2, _duplicateStaticRef$v2;
      (_tableRef$value2 = tableRef.value) === null || _tableRef$value2 === void 0 || _tableRef$value2.searchData(obj);
      (_duplicateStaticRef$v2 = duplicateStaticRef.value) === null || _duplicateStaticRef$v2 === void 0 || _duplicateStaticRef$v2.getOrderStatistics(obj);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(FilterHeader, {
        onFilterSubmit: filterSubmit,
        loading: loading.value
      }, null, 8, ["loading"]), _unref(permissionMessage) ? (_openBlock(), _createBlock(IncomePermissionNotice, {
        key: 0,
        class: "page-permission-notice",
        message: _unref(permissionMessage)
      }, null, 8, ["message"])) : _createCommentVNode("", true), _createVNode(DuplicateStatic, {
        ref_key: "duplicateStaticRef",
        ref: duplicateStaticRef
      }, null, 512), _createVNode(DuplicateTable, {
        ref_key: "tableRef",
        ref: tableRef
      }, null, 512)]);
    };
  }
});